import { defineProfile } from "./define.js";

export const RETAIL_SHOP_PROFILE = defineProfile("retail_shop", {
  labels: ["contacts", "orders"],
  home: ["balances_due", "quotes_waiting", "payments_today", "orders_today", "unread_chats"],
  kpis: [
    "outstanding_balance",
    "quotes_accepted",
    "revenue",
    "orders",
    "conversations",
    "payments_today",
  ],
  panel: ["account", "quotes", "orders", "receipts"],
  quickActions: ["record_payment", "new_quote", "send_statement"],
  contactFields: [
    { key: "credit_limit", kind: "number", label: { ar: "حد الحساب", en: "Account limit" } },
    { key: "payment_terms", kind: "select", label: { ar: "شروط الدفع", en: "Payment terms" } },
  ],
  aiTools: [
    "search_kb",
    "search_products",
    "send_product",
    "get_my_balance",
    "check_order_status",
    "escalate",
  ],
  cloudStarterMenu: "shop_menu",
  replyStyle: {
    emoji: "few",
    format: "short_lines",
    greeting: "short",
    closing: "question",
    length: "brief",
  },
});
